
<template>
    <div>
        <div class="login_hint">

            <div class="loading_div" >
                <Spin fix v-if="login_loading">
                </Spin>
            </div>
            {{login_msg}}
        </div>

    </div>
</template>

<script>
var Base64 = require("js-base64").Base64;
import { http, open_new_page } from "@/utils/http.js";
export default {
    data() {
        return {
            login_msg:'😬登录中，请稍等..',
            login_loading:true,
            code: '',
            status: ''
        }


    },
    mounted() {
        var that = this

        // 取参数
        var query = this.$route.query
        console.log(query)
        this.code = query.code
        this.status = query.status
        var redirect_url_base64 = query.redirect_url
        console.log(redirect_url_base64)
        this.redirect_url =  Base64.decode(redirect_url_base64)
        console.log(123,this.redirect_url)

        
        // 判断是否有token
        var dx_token = this.$cookies.get("dx_token")
        if (dx_token) {
            console.log('有cookie')
            console.log(this.redirect_url)
            setTimeout(function () {
                open_new_page(that.redirect_url, '_self')
            }, 500);
        } else {
            this.login()
        }
        

    },

    methods: {
        login() {
            var that = this
            let body_data = {
                code: this.code,
                status: this.status,
                redirect_url: this.redirect_url,
                browser_id: that.$cookies.get("dx_browser_id"),

            };

            var body = Base64.encode(JSON.stringify(body_data));
            var obj = {
                data: body,
            };

            http("post", process.env.VUE_APP_HOST + "/login_dx/wxmp_login", obj, false)
                .then((res) => {
                    if (res.code == 0) {
                        const msg = this.$Message.loading({
                            content: res.msg,
                            duration: 0,
                        });
                        var b64_str = Base64.decode(res.data)
                        var data = JSON.parse(b64_str)

                        that.$cookies.set(
                            "dx_token",
                            data.token,
                            data.cookie_exp,
                            '/',
                            process.env.VUE_APP_COOKIES_DOMAIN
                        );
                        that.$cookies.set(
                            "dx_private_key",
                            data.private_key,
                            data.cookie_exp,
                            '/',
                            process.env.VUE_APP_COOKIES_DOMAIN
                        );
                        that.$cookies.set(
                            "dx_public_key",
                            data.public_key,
                            data.cookie_exp,
                            '/',
                            process.env.VUE_APP_COOKIES_DOMAIN
                        );

                        that.$cookies.set(
                            "dx_user_info",
                            data.user_info,
                            data.cookie_exp,
                            '/',
                            process.env.VUE_APP_COOKIES_DOMAIN
                        );


                        var db_redirect_url = data.redirect_url
                        console.log(db_redirect_url)

                        setTimeout(function () {
                            open_new_page(db_redirect_url, '_self')
                        }, 500);
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                        that.login_loading=false
                        that.login_msg = '☹️'+res.msg
                    }
                })
                .catch((res) => {
                    console.log(res, "请求出错");
                });

        }
    }
}
</script>

<style  scoped>
.login_hint {
    text-align: center;
    padding-top: 100px;
}

.loading_div {
    padding: 40px 20px;
    position: relative;
}
</style>